/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './letter-template-rest.service';
export * from './letter-template.dto';
